exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".catalog-product-box {\n  position: relative; }\n  .catalog-product-box .productTags {\n    position: absolute;\n    top: 5px;\n    left: 5px; }\n    .catalog-product-box .productTags span {\n      padding: 2px 6px;\n      margin-bottom: 2px;\n      font-size: 9pt;\n      color: #FFF; }\n  .catalog-product-box img {\n    max-width: 100% !important;\n    max-height: 140px !important;\n    width: auto !important; }\n  .catalog-product-box .ant-card-meta-description {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./src/scenes/Catalog/style.scss
// module id = ../node_modules/css-loader/index.js!../node_modules/sass-loader/lib/loader.js!./src/scenes/Catalog/style.scss
// module chunks = 0